import type { AppDefinition } from '../../types/apps';

export const InboxAppDefinition: AppDefinition = {
  appId: 'inbox-app',
  name: 'Inbox',
  version: '1.0.0',
  description: 'AI-powered inbox for notifications, briefings, and triage results.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Tray',
    phosphorWeight: 'duotone',
    color: '#3b82f6',
  },
  component: 'InboxApp',
  entityTypes: ['InboxApp'],
  requiresProps: false,
  requiresEntity: true,
};
